import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styles from './Balance.scss';// todo:extract to general
import {Button, FormGroup, Label, Input, Col, Row, Container} from 'src/components/Common/reactstrap/lib';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import {map, memoize, orderBy, filter} from 'lodash';
import ScrollLoad from '../Common/ScrollLoad';
import moment from 'moment';
import "moment/locale/ru";


import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';

import {fetchUserTransaction} from './redux/userAction';
import SelectDate from '../Common/SelectDate';

export class Balance extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    this.state = {
      from: new Date(now.setDate(now.getDate() - 30)),
      to: new Date(),
    };
    this.handleDayClick = this.handleDayClick.bind(this);

    this.getBalance();

  }
  getBalance = (page= 0) => {
    console.log(page);
    let {from, to} = this.state,
      filters = {
        startDate: moment(from).format('YYYY.MM.DD'),
        finishDate: moment(to).add(1, 'd').format('YYYY.MM.DD'),
        rowsCount: 100,
        page,
      };
    this.props.fetchUserTransaction(filters);
  };
  handleDayClick(range) {
    this.setState(range, this.getBalance);
  }
  render() {
    console.log(this);
    let {from, to} = this.state,
      {Transactions, Balance} = this.props.userData;


    //let transactions = orderBy(Transactions.payments, 'date', 'desc');
    const tableRows = map(Transactions.payments, (value, i) => {
      return (
        <tr key={value.date + value.amount + value.isPayment}>
          <td>
            {moment(value.date).format('ll')}
          </td>
          <td>
            {value.operation}
          </td>
          <td className="last-row">
            <span className={(value.isPayment) ? 'text-success' : 'text-danger'}>
              {(value.isPayment) ? '+' : '-' } {value.amount.toLocaleString()} &#8381;
            </span>
          </td>
        </tr>
      );

    });
    const thead = (
      <thead>
      <tr>
        <th>Дата</th>
        <th>Операция</th>
        <th>Сумма, &#8381;</th>
      </tr>
      </thead>
    );

    return (
            <Container>
              <Breadcrumbs
                routes={this.props.routes}/>
              <h2>Баланс</h2>
              <Row>
                <Col sm={5}>
                  <Row>
                    <Col sm={8}>
                      <h3>Текущий остаток <span className={+Balance >= 0 ?"text-success" : "text-danger"}>{Balance.toLocaleString()} &#8381;</span></h3>
                    </Col>
                    <Col sm={4}>
                      <Button className="btn-wide m-t-0_5">Пополнить</Button>
                    </Col>
                    {/*<Col sm={12}><h3 className="m-b-0">Кредитный лимит 250 000 &#8381;</h3></Col>
                     <Col sm={12}><h3 className="m-t-0 m-r-2">Использовано 0 &#8381;</h3></Col>*/}
                  </Row>
                </Col>
                <Col sm={12}>{/*<h3>График платежей</h3>
                 Будет доступен после использования кредитного лимита*/}
                  <Row>
                    <Col className={styles.custom_col_2}>
                      <h3> Проводки за</h3>
                    </Col>
                    <Col className={styles.custom_col_3}>
                      <SelectDate
                        placement="bottom left"
                        from={from}
                        to={to}
                        setDate={this.handleDayClick}
                      />
                    </Col>
                  </Row>
                  <ScrollLoad
                    header={thead}
                    className={styles.table}
                    loadItems={this.getBalance}
                    hasMoreItems={Transactions.isNext}
                    page={Transactions.page}>
                    {tableRows}
                  </ScrollLoad>
          </Col>
        </Row>

      </Container>
    );
  }
}

Balance.routeTitle = "Баланс";
export default connect(
  (state) => ({
    userData: state.userReducer
  }),
  (dispatch) => ({
    fetchUserTransaction: bindActionCreators(fetchUserTransaction, dispatch)
  })
)(Balance);



/** WEBPACK FOOTER **
 ** ./src/components/User/Balance.jsx
 **/